import React, { Component } from 'react'
import {Link} from "react-router-dom";



export default class ListOption extends Component {

	constructor(props) {
		super(props);

		this.state = {
			wow_duration: 1,
		};

	}

	render() {

		// Lecture directe des props : la liste peut arriver après le montage
		// (chargement depuis l'API). Une copie figée dans le constructeur
		// resterait vide.
		const title = this.props.title || '';
		const description = this.props.description || '';

		let list = [];
		let wow_delay = 0.0;

		for (let l of (this.props.list || [])) {
			let titleSplit = l.title.split(' ');
			let title = titleSplit.length > 1 ? (<> <span>{ titleSplit[0] }</span> { titleSplit.splice(1).join(' ') } </>) : <span>{ l.title }</span>;

			list.push(
				<div className="col-lg-3 col-md-6" key={wow_delay}>
					<Link to={ l.link ? l.link : '#' }>
						<div className="single-service wow fadeInUp" data-wow-duration={ `${this.state.wow_duration}s` } data-wow-delay={ `${wow_delay}s` }>
							{/*Use icon https://linearicons.com/free*/}
							<span className={ `lnr ${l.lnr_icon ? l.lnr_icon : 'lnr-list'}` }> </span>
							<h4>
								{ title }
							</h4>
							<p>{ l.description }</p>
						</div>
					</Link>
				</div>
			);
			wow_delay += 0.2;
		}

		return (
			<>
				{/*Start Service Area*/}
				<section className="service-area section-gap white">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>{ title }</h2>
									<p>{ description }</p>
								</div>
							</div>
						</div>
						<div className="row">
							{ list }
						</div>
					</div>
				</section>
				{/*End Service Area*/}
			</>
		);
	}
}